import { useState } from 'react';

const nutrients = [
  {
    stat: '7×',
    label: 'More Vitamin C',
    compare: 'than oranges',
    icon: 'ri-sun-line',
    color: 'bg-amber-50 border-amber-200 text-amber-600',
    statColor: 'text-amber-600',
    image: 'https://public.readdy.ai/ai/img_res/2e05d8980b00d880c405bc3cf56a18b0.jpg',
  },
  {
    stat: '4×',
    label: 'More Calcium',
    compare: 'than milk',
    icon: 'ri-seedling-line',
    color: 'bg-green-50 border-green-200 text-green-600',
    statColor: 'text-green-600',
    image: 'https://readdy.ai/api/search-image?query=Pure%20moringa%20green%20powder%20in%20a%20wooden%20spoon%20alongside%20fresh%20milk%20in%20glass%2C%20clean%20white%20minimal%20background%2C%20natural%20bone%20health%20nutrition%20concept%2C%20organic%20superfood%20photography&width=320&height=200&seq=moringa-calcium&orientation=landscape',
  },
  {
    stat: '3×',
    label: 'More Potassium',
    compare: 'than bananas',
    icon: 'ri-heart-pulse-line',
    color: 'bg-lime-50 border-lime-200 text-lime-700',
    statColor: 'text-lime-700',
    image: 'https://readdy.ai/api/search-image?query=Moringa%20powder%20and%20fresh%20yellow%20bananas%20on%20light%20neutral%20background%2C%20potassium%20rich%20superfood%2C%20clean%20food%20photography%20with%20natural%20textures%2C%20health%20nutrition%20comparison%20flat%20lay&width=320&height=200&seq=moringa-potassium&orientation=landscape',
  },
  {
    stat: '2×',
    label: 'More Protein',
    compare: 'than yoghurt',
    icon: 'ri-body-scan-line',
    color: 'bg-teal-50 border-teal-200 text-teal-600',
    statColor: 'text-teal-600',
    image: 'https://readdy.ai/api/search-image?query=Green%20moringa%20powder%20scooped%20into%20a%20bowl%20next%20to%20yoghurt%20cup%20on%20white%20stone%20surface%2C%20protein%20nutrition%20comparison%2C%20clean%20minimal%20food%20photography%2C%20natural%20health%20supplement&width=320&height=200&seq=moringa-protein&orientation=landscape',
  },
];

const testimonials = [
  {
    name: 'Abena Asante',
    location: 'Accra, Ghana',
    role: 'Wellness Coach',
    rating: 5,
    text: 'I have been recommending MY AVA Farms moringa powder to all my clients. The purity and quality is unmatched — you can taste the freshness. My energy levels have genuinely improved since I started adding it to my morning smoothies.',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20Ghanaian%20woman%20wellness%20coach%20in%20her%2030s%2C%20warm%20professional%20headshot%2C%20natural%20background%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20expression&width=80&height=80&seq=avatar-abena&orientation=squarish',
  },
  {
    name: 'Kwame Osei',
    location: 'Kumasi, Ghana',
    role: 'Nutritionist',
    rating: 5,
    text: 'As a nutritionist, I am very particular about supplement quality. This moringa powder is exceptional — vibrant green colour, fresh aroma, and no fillers. My patients have seen real improvements in their iron levels and overall vitality.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Ghanaian%20male%20nutritionist%20in%20his%2040s%2C%20warm%20confident%20headshot%20portrait%2C%20casual%20professional%20attire%2C%20natural%20studio%20lighting%2C%20friendly%20smile&width=80&height=80&seq=avatar-kwame&orientation=squarish',
  },
  {
    name: 'Efua Mensah',
    location: 'Takoradi, Ghana',
    role: 'Mother of Three',
    rating: 5,
    text: 'I mix this into soups and porridge for my family every day. The children do not even notice it! Since we started using it, everyone seems healthier and my youngest daughter\'s anaemia has improved tremendously. Truly a gift from nature.',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20Ghanaian%20woman%20mother%20in%20her%2030s%20with%20a%20kind%20smile%2C%20natural%20background%2C%20soft%20warm%20lighting%2C%20approachable%20and%20happy%20expression&width=80&height=80&seq=avatar-efua&orientation=squarish',
  },
  {
    name: 'Dr. Isaac Boateng',
    location: 'Tema, Ghana',
    role: 'General Practitioner',
    rating: 5,
    text: 'I now recommend MY AVA Farms moringa powder as a natural supplement to patients managing blood sugar and inflammation. The quality is consistent, and knowing it is locally grown and sustainably processed gives extra confidence.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Ghanaian%20male%20doctor%20in%20his%2040s%20wearing%20scrubs%2C%20friendly%20confident%20headshot%2C%20clean%20clinic%20background%2C%20warm%20professional%20lighting&width=80&height=80&seq=avatar-isaac&orientation=squarish',
  },
  {
    name: 'Ama Darkoa',
    location: 'Accra, Ghana',
    role: 'Fitness Enthusiast',
    rating: 5,
    text: 'Post-workout recovery has never been easier. I blend a teaspoon into my protein shake every morning. The anti-inflammatory benefits are real — less soreness, more energy, and my skin has never looked better!',
    avatar: 'https://readdy.ai/api/search-image?query=Energetic%20Ghanaian%20woman%20fitness%20enthusiast%20in%20her%20late%2020s%2C%20sporty%20casual%20attire%2C%20bright%20natural%20background%2C%20vibrant%20healthy%20appearance%2C%20confident%20headshot&width=80&height=80&seq=avatar-ama&orientation=squarish',
  },
  {
    name: 'Kofi Agyeman',
    location: 'Cape Coast, Ghana',
    role: 'Organic Farmer',
    rating: 5,
    text: 'As someone who grows food, I know quality when I taste it. This moringa is processed with real care — no heat damage, no additives. The fact that it comes from a Ghanaian farm that I can trust makes all the difference.',
    avatar: 'https://readdy.ai/api/search-image?query=Proud%20Ghanaian%20male%20farmer%20in%20his%2050s%20outdoor%20portrait%2C%20traditional%20clothing%2C%20lush%20green%20farm%20background%2C%20warm%20sunlight%2C%20authentic%20hardworking%20expression&width=80&height=80&seq=avatar-kofi&orientation=squarish',
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
      ))}
    </div>
  );
}

export default function MoringaTestimonials() {
  const [activeTab, setActiveTab] = useState<'benefits' | 'reviews'>('benefits');

  return (
    <section className="py-24 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center bg-green-50 text-green-700 text-xs font-semibold px-4 py-1.5 rounded-full border border-green-200 uppercase tracking-widest mb-4">
            <i className="ri-leaf-line mr-2"></i>Moringa Spotlight
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why People Love Our <span className="text-green-600">Moringa Powder</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Backed by science and trusted by hundreds of Ghanaians — discover what makes our pure moringa powder a daily essential.
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white border border-gray-200 rounded-full px-1 py-1">
            <button
              onClick={() => setActiveTab('benefits')}
              className={`px-6 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'benefits'
                  ? 'bg-green-600 text-white'
                  : 'text-gray-500 hover:text-gray-800'
              }`}
            >
              <i className="ri-heart-pulse-line mr-2"></i>Health Benefits
            </button>
            <button
              onClick={() => setActiveTab('reviews')}
              className={`px-6 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'reviews'
                  ? 'bg-green-600 text-white'
                  : 'text-gray-500 hover:text-gray-800'
              }`}
            >
              <i className="ri-chat-quote-line mr-2"></i>Customer Reviews
            </button>
          </div>
        </div>

        {/* Benefits Tab */}
        {activeTab === 'benefits' && (
          <div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
              {nutrients.map((item, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-2xl border overflow-hidden hover:-translate-y-1 transition-transform duration-300 ${item.color.split(' ')[1]}`}
                >
                  <div className="w-full h-40 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.label}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5">
                    <div className={`text-4xl font-extrabold mb-1 ${item.statColor}`}>{item.stat}</div>
                    <p className="text-gray-900 font-semibold text-sm leading-tight">{item.label}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{item.compare}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Usage Ideas */}
            <div className="bg-white rounded-2xl border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">Ways to Use Moringa Powder Daily</h3>
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-cup-line', title: 'Morning Smoothies', desc: 'Blend a teaspoon into your fruit smoothie for an energising start.' },
                  { icon: 'ri-bowl-line', title: 'Soups & Stews', desc: 'Stir into your favourite Ghanaian soups right before serving to preserve nutrients.' },
                  { icon: 'ri-bread-line', title: 'Baking & Cooking', desc: 'Add to bread, porridge, or rice dishes for a nutritious boost.' },
                  { icon: 'ri-water-flash-line', title: 'Moringa Tea', desc: 'Dissolve in warm (not boiling) water with honey for a soothing wellness drink.' },
                ].map((use, i) => (
                  <div key={i} className="flex flex-col items-center text-center p-4 bg-green-50 rounded-xl">
                    <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mb-3">
                      <i className={`${use.icon} text-green-600 text-xl`}></i>
                    </div>
                    <h4 className="font-semibold text-gray-900 text-sm mb-1">{use.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{use.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Reviews Tab */}
        {activeTab === 'reviews' && (
          <div>
            {/* Rating Summary */}
            <div className="bg-green-600 rounded-2xl p-8 mb-10 flex flex-col sm:flex-row items-center justify-center gap-8 text-white">
              <div className="text-center">
                <div className="text-6xl font-extrabold mb-1">5.0</div>
                <StarRating count={5} />
                <p className="text-green-200 text-sm mt-1">Average Rating</p>
              </div>
              <div className="hidden sm:block w-px h-16 bg-green-400"></div>
              <div className="grid grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-3xl font-bold">100%</div>
                  <p className="text-green-200 text-xs mt-1">Would Recommend</p>
                </div>
                <div>
                  <div className="text-3xl font-bold">200+</div>
                  <p className="text-green-200 text-xs mt-1">Happy Customers</p>
                </div>
                <div>
                  <div className="text-3xl font-bold">6</div>
                  <p className="text-green-200 text-xs mt-1">Regions Served</p>
                </div>
              </div>
            </div>

            {/* Testimonial Cards */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {testimonials.map((t, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl border border-gray-100 p-6 hover:-translate-y-1 transition-transform duration-300"
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-full overflow-hidden shrink-0">
                        <img
                          src={t.avatar}
                          alt={t.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900 text-sm">{t.name}</p>
                        <p className="text-gray-400 text-xs">{t.role} · {t.location}</p>
                      </div>
                    </div>
                    <i className="ri-double-quotes-r text-3xl text-green-100"></i>
                  </div>
                  <StarRating count={t.rating} />
                  <p className="text-gray-600 text-sm leading-relaxed mt-3">{t.text}</p>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </section>
  );
}
